import request from '@/utils/request'
const baseUrl = process.env.VUE_APP_PURCHASE_API
const portalUrl = process.env.VUE_APP_PORTAL_API

// 统计已参与的询比
export function getInquireOrdersTotalApi() {
  return request({
    url: baseUrl + '/workbench/supplier/inquiry-orders/process/total',
    method: 'get'
  })
}

// 已参与的询比
export function getInquireOrdersPageApi(query) {
  return request({
    url: baseUrl + '/workbench/supplier/inquiry-orders/process/page',
    method: 'get',
    params: query
  })
}

// 统计已参与的招标采购
export function getBiddingOrdersTotalApi() {
  return request({
    url: baseUrl + '/workbench/v2/supplier/bidding-orders/process/total',
    method: 'get'
  })
}

// 已参与的招标采购
export function getBiddingOrdersPageApi(query) {
  return request({
    url: baseUrl + '/workbench/v2/supplier/bidding-orders/process/page',
    method: 'get',
    params: query
  })
}

// 统计已参与的竞价
export function getCompetitionOrdersTotalApi() {
  return request({
    url: baseUrl + '/workbench/supplier/competition-orders/process/total',
    method: 'get'
  })
}

// 已参与的竞价
export function getCompetitionOrdersPageApi(query) {
  return request({
    url: baseUrl + '/workbench/supplier/competition-orders/process/page',
    method: 'get',
    params: query
  })
}

// 供应商统计已参与的招募
export function getRecruitOrdersTotalApi() {
  return request({
    url: baseUrl + '/workbench/supplier/participates/recruit-orders/total',
    method: 'get'
  })
}

// 供应商查询已参与的招募
export function getRecruitOrdersPageApi(params) {
  return request({
    url: baseUrl + '/workbench/supplier/participates/recruit-orders/page',
    method: 'get',
    params
  })
}

// 供应商统计已参与的谈判采购
export function getNegotiationOrdersTotalApi() {
  return request({
    url: baseUrl + '/workbench/v2/supplier/hosp-negotiate-orders/process/total',
    method: 'get'
  })
}

// 供应商查询已参与的谈判采购
export function getNegotiationOrdersPageApi(params) {
  return request({
    url: baseUrl + '/workbench/v2/supplier/hosp-negotiate-orders/process/page',
    method: 'get',
    params
  })
}

// 工作台-查询公告
export function getNoticeListApi(params) {
  return request({
    url: portalUrl + '/search/notice/page',
    method: 'get',
    params
  })
}
